module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4821bcce8d07e55dfec6d5dee576b6bd.png";